import { PermissionService } from './../../../service/permission.service';
import { LeadReportsSuccessAction, LeadReportsRequestAction } from './../../../modules/shared/stores/leadReportsDataStore/leadReportsData.actions';
import { LeadReportsStoreModels } from './../../../modules/shared/stores/leadReportsDataStore/leadReportsData.state';
import { selectorLeadReportsAllData } from './../../../modules/shared/stores/leadReportsDataStore/leadReportsData.selectors';
import { RootReducerState } from './../../../modules/shared/stores/ngrx.imports';
import { DATE_RANGE_LIST } from './../../../modules/shared/constants/date-range-list.constants';
import { ReportsAllFiltersAppyModels, ReportsAllFiltersApplyModes, typeReportsAllFiltersApplyModes } from './../../models/reports-all-filter-appy.models';
import { LeadReportsFiltersModels } from './../../../models/lead-reports/lead-reports-filters.models';
import { ClosedLeadsOwnerReports } from './../../models/closed-leads-owner-reports';
import { IReportsFilterModel } from './../../models/reports-filter.models';
import { ReportsPrintPdfService } from './../../servies/reports-print-pdf.service';
import { PercentageSymbolPipe } from '../../../modules/shared/pipes/percentage-symbol.pipe';
import { CurrencySymbolPipe } from '../../../modules/shared/pipes/currency-symbol.pipe';
import { LocalDatePipe } from './../../../shared/pipes/local-date.pipe';
import { CellDef } from 'jspdf-autotable';
import { ParseHelper } from '../../../modules/shared/parse.helper';
import { OnDestroy, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { IReportsDataServiceLeftMenuExpantionModel, IReportsDataServiceTopMenuModel, ReportsDataServiceModelValues, ReportsTopMenuItemsValues } from './../../models/reports-data-service-model';
import { DataService } from './../../dataService';
import { ReportsLeadsPermissions, ReportsLeadsRoutes, ReportsLeadsTypes } from './../../models/reports-leads.enums';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import * as FileSaver from 'file-saver';
import { Subscription, Subject } from 'rxjs';
import { AppMainService } from '../../../app-main.service';
import { AppMainComponent } from '../../../app.main.component';
import { ReportService } from '../../reportService';
import { Store } from '@ngrx/store';
import { getLeadReportsStoredData } from '../../../modules/shared/stores/leadReportsDataStore/leadReportsData.compare';

@Component({
    selector: 'app-reports-leads',
    templateUrl: './reports-leads.component.html',
    styleUrls: ['./reports-leads.component.scss'],
    providers: [CurrencySymbolPipe, PercentageSymbolPipe]
})
export class ReportsLeadsComponent implements OnInit, OnDestroy, OnChanges {

    //#region Properties
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    subscription: Subscription = new Subscription();

    @Input() selectedReportFilters: LeadReportsFiltersModels;
    @Input() selectedWindow: string = '';
    @Input() dashboardView: string = "";
    @Input() dateFrom: any;
    @Input() dateTo: any;
    @Input() displayFilterPopup: boolean = false;
    @Output() onCloseFilterPopup: EventEmitter<any> = new EventEmitter<any>();
    @Input() reloadContent: boolean = false;
    @Output() onReloadContent: EventEmitter<any> = new EventEmitter<any>();
    @Output() onLastReloadTime: EventEmitter<any> = new EventEmitter<Date>();
    @Output() onUpdateAllFilters: EventEmitter<ReportsAllFiltersAppyModels> = new EventEmitter<ReportsAllFiltersAppyModels>();
    reportsFilterApplyMode: typeReportsAllFiltersApplyModes|"" = "";
    reportsDataLoaded: boolean = false;
    filterPopupHeader: string = "Filter";
    loadReportsFirstTime: boolean = false;
    leadsReportsLoading: boolean = false;

    public reportName: string = '';
    public reportDate: any;
    public selectedRepFilter = { name: "All", userName: "All", id: 0 };
    public filterDataByLeadStage: any[] = [];
    public selectedDateFilter: any = null;
    public selectedFilterGroup: IReportsFilterModel[] = [];
    public showChannelFileter: boolean;
    public Months: any[] = [];
    public cols: any;
    public tableCols: any;
    public reportsData: any[] = [];
    public reportsDataCopy = [];
    public filterByInputValue: any[] = [];// available value pass to filter component
    public reportsFlatData = [];// available value pass to table component
    public chartLabel;
    public barData;
    public stackedData;
    public basicOptions;
    public stackedOptions;
    public totalRecords: number;
    public totalPages: number;
    public IsShowReportTemplate: boolean = true;
    public noContactFindOrLoadingText = 'Loading....';
    public OrganizationName = "";
    public leadsChannelList: any[] = [];
    //#endregion

    //CTOR

    showChannelFilter: boolean = false;
    channelList: any[] = [];
    selectedChannel = null;

    groupByFieldName = "";

    leadsOwnerBarCharts: any;
    leadsStageBarCharts: any;

    constructor(
        private store: Store<RootReducerState>,
        public app: AppMainComponent,
        private appMainService: AppMainService,
        private reportService: ReportService,
        private router: ActivatedRoute,
        private dataService: DataService,
        public localDatePipe: LocalDatePipe,
        private currencySymbolPipe: CurrencySymbolPipe,
        private percentageSymbolPipe: PercentageSymbolPipe,
        private permissionService: PermissionService
    ) {
        this.dataService.getData<IReportsDataServiceTopMenuModel>().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(data => {
            if (data.actionType == ReportsDataServiceModelValues.reportsTopMenuItems) {
                if (data.value == ReportsTopMenuItemsValues.print) {
                    this.print();
                }
                else if (data.value == ReportsTopMenuItemsValues.PDF) {
                    this.exportPDF(this.selectedWindow, false);
                }
                else if (data.value == ReportsTopMenuItemsValues.XLS) {
                    this.exportXLS(this.selectedWindow)
                }
                else if (data.value == ReportsTopMenuItemsValues.XLSX) {
                    this.exportXLSX(this.selectedWindow)
                }
                else if (data.value == ReportsTopMenuItemsValues.Refresh) {
                    this.selectedFilterGroup = [];
                    this.LeadReport();
                }
            }
        });
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    ngOnChanges(changes: SimpleChanges){
        if(changes?.selectedWindow?.currentValue){
            this.selectedWindow = changes.selectedWindow.currentValue;
            if(this.loadReportsFirstTime) this.loadChartDataOnly();
        }

        if(changes?.displayFilterPopup){
            this.displayFilterPopup = changes.displayFilterPopup?.currentValue||false;
        }

        if(changes?.reloadContent && changes?.reloadContent?.currentValue){
            this.reloadContent = true;
            this.loadReportsFirstTime = true;
            this.loadChartDataOnly();
        }

        if(changes?.selectedReportFilters && changes?.selectedReportFilters?.currentValue){
            this.selectedReportFilters = changes?.selectedReportFilters?.currentValue;
            if(this.loadReportsFirstTime) this.setSelectedFilters();
        }
    }

    async ngOnInit() {
        !this.dashboardView && this.appMainService.isShowSpinner('channelLoader');
        this.leadsReportsLoading = true;
        this.leadsChannelList = await this.dataService.getLeadChannelList();
        this.appMainService.isHideSpinner('channelLoader');
        this.leadsReportsLoading = false;

        if(this.dashboardView){
            this.loadReportsFirstTime = true;
            this.loadChartDataOnly();
        }else{
            this.subscription = this.router.paramMap.subscribe((param: any) => {
                const activityType = param.params.type;

                switch (activityType) {
                    case ReportsLeadsRoutes.leadsActivity:
                        this.selectedWindow = ReportsLeadsTypes.leadsActivity;
                        break;
                    case ReportsLeadsRoutes.leadsAging:
                        this.selectedWindow = ReportsLeadsTypes.leadsAging;
                        break;
                    case ReportsLeadsRoutes.leadsConversion:
                        this.selectedWindow = ReportsLeadsTypes.leadsConversion;
                        break;
                    case ReportsLeadsRoutes.leadsConversionSummary:
                        this.selectedWindow = ReportsLeadsTypes.leadsConversionSummary;
                        break;
                    case ReportsLeadsRoutes.leadsConverted:
                        this.selectedWindow = ReportsLeadsTypes.leadsConverted;
                        break;
                    case ReportsLeadsRoutes.leadsCreatedate:
                        this.selectedWindow = ReportsLeadsTypes.leadsCreatedate;
                        break;
                    case ReportsLeadsRoutes.leadsIndustry:
                        this.selectedWindow = ReportsLeadsTypes.leadsIndustry;
                        break;
                    case ReportsLeadsRoutes.leadsNoActivity:
                        this.selectedWindow = ReportsLeadsTypes.leadsNoActivity;
                        break;
                    case ReportsLeadsRoutes.leadsOwner:
                        this.selectedWindow = ReportsLeadsTypes.leadsOwner;
                        break;
                    case ReportsLeadsRoutes.leadsSource:
                        this.selectedWindow = ReportsLeadsTypes.leadsSource;
                        break;
                    case ReportsLeadsRoutes.leadsStage:
                        this.selectedWindow = ReportsLeadsTypes.leadsStage;
                        break;
                    case ReportsLeadsRoutes.leadsType:
                        this.selectedWindow = ReportsLeadsTypes.leadsType;
                        break;
                    default:
                        break;
                }

                this.setDefaultChannel();
                this.cols = [];//clear filter
                this.tableCols = [];
                this.groupByFieldName = "";
                this.reportsData = [];
                this.setClosedLeadsOwnerCharts();
                this.setLeadStageBarChart();
                this.LeadReport();

                this.dataService.sendData<IReportsDataServiceLeftMenuExpantionModel>({ actionType: ReportsDataServiceModelValues.reportsLeftMenuExpansion, value: this.selectedWindow });
            });
        }

    }

    loadChartDataOnly(){
        this.cols = [];//clear filter
        this.tableCols = [];
        this.groupByFieldName = "";
        this.reportsData = [];
        this.setClosedLeadsOwnerCharts();
        this.setLeadStageBarChart();

        this.setSelectedFilters();
        this.setAddedFilters();
        if(!this.selectedReportFilters?.dateFilter){
            this.LeadReport();
        }
    }

    setSelectedFilters(){
        this.setDefaultChannel(this.selectedReportFilters?.leadChannelId||0)

        if(this.selectedReportFilters?.dateFilter){
            this.selectedDateFilter = {
                label: this.selectedReportFilters.dateFilter,
                code: this.selectedReportFilters.dateFilter,
                fromDate: this.selectedReportFilters?.fromDate||null,
                toDate: this.selectedReportFilters?.toDate||null
            }
        }
    }

    setDefaultChannel(channelId: number = 0){
        this.showChannelFilter = true;
        this.channelList = this.permissionService.filterChannelsByReportPermissions(this.leadsChannelList, ReportsLeadsPermissions[this.selectedWindow]);

        const channelExist = this.channelList.find(channel=>channel?.id==channelId);

       if(channelExist && channelId){
            this.selectedChannel = channelExist;
       }else{
            this.selectedChannel = this.channelList ? this.channelList.find(el=>el.isDefault==true)||this.channelList[0] : null;
       }
    }

    LeadReport() {
        const getReportsData = this.store.select(selectorLeadReportsAllData);

        !this.dashboardView && this.appMainService.isShowSpinner('LeadReport');
        this.OrganizationName = this.app.user.organizationName;
        this.reportsDataLoaded = false;
        this.leadsReportsLoading = true;

        const addedFilters: LeadReportsFiltersModels = {
            dateFilter: this.selectedDateFilter?.code,
            fromDateOnly: this.formatDate(this.dateFrom),
            toDateOnly: this.formatDate(this.dateTo),
            leadChannelId: this.selectedChannel?.id||0
        }

        getReportsData.subscribe(storedData=>{
            // console.log(storedData)

            const results = getLeadReportsStoredData(storedData,this.selectedWindow,addedFilters);
            // console.log(results);
            if(results.index > -1 && this.dashboardView!='' && !this.reloadContent && this.reportsFilterApplyMode==""){
                const updatedTime: Date = results?.data?.loadedTime ? new Date( results?.data?.loadedTime) : new Date();
                this.onLastReloadTime.emit(updatedTime);
                this.setReportsResponse(results?.data?.reportsData||[]);
                this.setReportsFinalResponse();
            }else{
                this.reloadContent = false;
                this.loadNewReportsData(addedFilters);
            }

        });

    }

    loadNewReportsData(addedFilters: LeadReportsFiltersModels){
        if(this.dashboardView!='' && this.reportsFilterApplyMode!=ReportsAllFiltersApplyModes.applyOnly){
            this.store.dispatch(new LeadReportsRequestAction());
        }

        if(!this.selectedWindow || !addedFilters.leadChannelId) {
            return;
        }

        this.reportService.LeadsReport(addedFilters.leadChannelId||0, addedFilters.fromDateOnly, addedFilters.toDateOnly, this.selectedWindow).then(res => {
            this.appMainService.isHideSpinner('LeadReport');
            let { contacts, headers } = res;
            contacts = contacts.length > 0 ? this.formatedData(contacts) : [];
            let results = ParseHelper.DeepCopy(contacts)||[];
            const updatedTime: Date = new Date();
            this.onLastReloadTime.emit(updatedTime);
            this.setReportsResponse(results);

            if(this.dashboardView!='' && this.reportsFilterApplyMode!=ReportsAllFiltersApplyModes.applyOnly){
                this.setLeadReportsStoreData(results,addedFilters);
            }

            this.reportsFilterApplyMode = "";

        }).finally(() => {
            this.setReportsFinalResponse();
        });
    }

    setReportsResponse(responseData){
        this.reportsData = responseData;
        this.reportsDataCopy = ParseHelper.DeepCopy(responseData);
        this.filterByInputValue = ParseHelper.DeepCopy(responseData);
        this.reportsDataLoaded = true;
        this.leadsReportsLoading = false;
        this.appMainService.isHideSpinner('LeadReport');
    }

    setReportsFinalResponse(){
        //set filtered cols
        this.reportsDataLoaded = true;
        this.leadsReportsLoading = false;
        this.setFilterCols();
        //this.setCustomFilters();
        this.appMainService.isHideSpinner('LeadReport');
        this.noContactFindOrLoadingText = 'No Reports Available.';
        this.onReloadContent.emit(false);
    }

    setLeadReportsStoreData(results: any, addedFilters: LeadReportsFiltersModels){
        const reportsData: LeadReportsStoreModels = {
            reportsData: results,
            reportType: this.selectedWindow,
            loadedTime: new Date(),
            addedFilters: addedFilters,
            loading: false,
            loaded: true
        }

        this.store.dispatch(new LeadReportsSuccessAction(reportsData));
    }

    formatedData(results){
        let dataResults = ParseHelper.DeepCopy(results);

        switch (this.selectedWindow) {
            case ReportsLeadsTypes.leadsOwner: {
                let leadsOwnerDataResults: ClosedLeadsOwnerReports[] = [];

                results.map(leadsOwnerData=>{
                    let {lead_Detail, ...ownerDetails} = leadsOwnerData;
                    lead_Detail.map(details=>{
                        leadsOwnerDataResults.push({
                        ...ownerDetails,
                        ...details
                       })
                    })
                });

                dataResults = ParseHelper.DeepCopy(leadsOwnerDataResults);
                break;
            }
            case ReportsLeadsTypes.leadsStage: {
                let leadsOwnerDataResults: any[] = [];

                results.map(leadsOwnerData=>{
                    let {lead_Detail, ...ownerDetails} = leadsOwnerData;
                    lead_Detail.map(details=>{
                        leadsOwnerDataResults.push({
                        ...ownerDetails,
                        ...details
                       })
                    })
                });

                dataResults = ParseHelper.DeepCopy(leadsOwnerDataResults);
                break;
            }
            default: {
                break;
            }
        }

        return dataResults;
    }

    setFilterCols(): void {
        this.filterByInputValue = [];
        switch (this.selectedWindow) {
            case ReportsLeadsTypes.leadsOwner: {
                this.tableCols = [
                    {id: 1, field: 'leadOwnerEmail', groupField: 'leadOwner', header: 'Lead Owner', dataType: 'string', isShow: true },
                    {id: 2, field: 'leadName', header: 'Lead Name', dataType: 'string', isShow: true },
                    {id: 3, field: 'leadType', header: 'Lead Type', dataType: 'string', isShow: true },
                    {id: 4, field: 'leadSource', header: 'Lead Source', dataType: 'string', isShow: true },
                    {id: 5, field: 'createDate', header: 'Create Date', dataType: 'date', isShow: true },
                    {id: 6, field: 'closedDate', header: 'Closed Date', dataType: 'date', isShow: true },
                    {id: 7, field: 'leadStage', header: 'Lead Stage', dataType: 'string', isShow: true },
                ];
                this.cols = ParseHelper.DeepCopy(this.tableCols);
                this.cols[0].field = 'leadOwner';


                // let temp = [];
                // temp = this.formatedData(null)||[];
                // this.reportsData = temp;
                // this.reportsDataCopy = ParseHelper.DeepCopy(temp);
                // this.filterByInputValue = ParseHelper.DeepCopy(temp);


                this.reportName = 'Closed Leads By Owner';
                this.groupByFieldName = "leadOwner";
                this.chartLabel = `Lead Counts`;

                this.basicOptions = {
                    plugins: {
                        legend: {
                            labels: {
                                color: '#495057'
                            }
                        }
                    },
                    scales: {
                        x: {
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        },
                        y: {
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        }
                    }
                };
                break;
            }
            case ReportsLeadsTypes.leadsStage: {

                this.tableCols = [
                    { id: 1, field: '', groupField: 'leadStage', header: 'Lead Stage', dataType: 'string', isShow: true },
                    { id: 2, field: 'leadName', header: 'Lead Name', dataType: 'string', isShow: true },
                    { id: 3, field: 'leadType', header: 'Lead Type', dataType: 'string', isShow: true },
                    { id: 4, field: 'leadOwner', header: 'Lead Owner', dataType: 'string', isShow: true },
                    { id: 5, field: 'createDate', header: 'Create Date', dataType: 'date', isShow: true },
                    { id: 6, field: 'lastUpdateDate', header: 'Last Updated On', dataType: 'date', isShow: true },
                    { id: 7, field: 'lastUpdateBy', header: 'Last Updated by', dataType: 'string', isShow: true },
                ];

                this.cols = ParseHelper.DeepCopy(this.tableCols);
                this.cols[0].field = 'leadStage';
                this.reportName = 'Lead by Stage';
                this.groupByFieldName = "leadStage";

                this.chartLabel = `Lead Counts`;
                this.stackedOptions = {
                    tooltips: {
                        mode: 'index',
                        intersect: false
                    },
                    responsive: true,
                    plugins: {
                        tooltips: {
                            mode: 'index',
                            intersect: false
                        },
                        legend: {
                            labels: {
                                color: '#495057'
                            }
                        }
                    },
                    scales: {
                        x: {
                            stacked: true,
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        },
                        y: {
                            stacked: true,
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        }
                    }
                };
                break;
            }
            case ReportsLeadsTypes.leadsIndustry: {
                if (this.selectedRepFilter.name == 'All') {
                    this.cols = [
                        { field: 'industry', header: 'Industry' },
                    ];
                }
                else {
                    this.cols = [
                        { field: 'industry', header: 'Industry' },
                        { field: 'leadOwner', header: 'Lead Owner' },];
                }
                for (var i = 0; i < this.filterDataByLeadStage.length; i++) {
                    var leadStageName = this.filterDataByLeadStage[i].name + "";
                    if (leadStageName.toLowerCase() !== 'all')
                        this.cols.push({ field: this.camelize(leadStageName), header: leadStageName });
                }

                this.cols.push({ field: 'grandTotal', header: 'Grand Total' },);
                this.reportName = 'Lead by Industry';
                break;
            }
            case ReportsLeadsTypes.leadsActivity: {
                this.cols = [
                    { field: 'leadName', colspan: '2', header: 'Lead Name' },
                    { field: 'channel', header: 'Channel' },
                    { field: 'activityType', header: 'Activity Type' },
                    { field: 'comment', colspan: '3', header: 'Comment' },
                    { field: 'createDate', header: 'Created Date' },
                    { field: 'createdBy', header: 'Created By' },
                    { field: 'address', header: 'Address' },
                ];
                this.reportName = 'Lead by Activity';
                break;
            }
            case ReportsLeadsTypes.leadsConversion: {
                this.cols = [
                    { field: 'leadName', header: 'Lead Name' },
                    { field: 'leadSource', header: 'Lead Source' },
                    { field: 'leadCreatedDate', header: 'Lead Created Date' },
                    { field: 'primaryAssociate', header: 'Primary Associate' },
                    { field: 'convertedAccountName', header: 'Converted AccountName' },
                    { field: 'convertedDate', header: 'Converted Date' },
                    { field: 'convertedBy', header: 'Converted By' },
                ];
                this.reportName = 'Lead by Conversion';
                break;
            }
            case ReportsLeadsTypes.leadsConversionSummary: {
                this.cols = [
                    { field: 'primaryAssociate', header: 'Primary Associate' },
                    { field: 'leadCreated', header: 'Lead Created' },
                    { field: 'leadConverted', header: 'Lead Converted' },
                    { field: 'leadConversionRate', header: 'Lead Conversion Rate' },
                ];
                this.reportName = 'Lead by Conversion Summary';
                break;
            }
            case ReportsLeadsTypes.leadsType: {
                if (this.selectedRepFilter.name == 'All') {
                    this.cols = [
                        { field: 'leadType', header: 'Lead Type' },
                    ];
                }
                else {
                    {
                        this.cols = [
                            { field: 'leadType', header: 'Lead Type' },
                            { field: 'leadOwner', header: 'Lead Owner' },];
                    }

                }

                for (var i = 0; i < this.filterDataByLeadStage.length; i++) {
                    var leadStageName = this.filterDataByLeadStage[i].name + "";
                    if (leadStageName.toLowerCase() !== 'all')
                        this.cols.push({ field: this.camelize(leadStageName), header: leadStageName });
                }

                this.cols.push({ field: 'grandTotal', header: 'Grand Total' },);

                this.reportName = 'Lead by Type';
                break;
            }
            case ReportsLeadsTypes.leadsSource: {
                if (this.selectedRepFilter.name == 'All') {
                    this.cols = [
                        { field: 'source', header: 'Source' },
                    ];
                }
                else {
                    this.cols = [
                        { field: 'source', header: 'Source' },
                        { field: 'leadOwner', header: 'Lead Owner' },];
                }
                for (var i = 0; i < this.filterDataByLeadStage.length; i++) {
                    var leadStageName = this.filterDataByLeadStage[i].name + "";
                    if (leadStageName.toLowerCase() !== 'all')
                        this.cols.push({ field: this.camelize(leadStageName), header: leadStageName });
                }

                this.cols.push({ field: 'grandTotal', header: 'Grand Total' },);
                this.reportName = 'Lead by Source';
                break;
            }
            case ReportsLeadsTypes.leadsCreatedate: {
                var months = this.monthList(new Date(this.dateFrom), new Date(this.dateTo));

                if (this.selectedRepFilter.name == 'All') {
                    this.cols = [{ field: 'leadStage', header: 'Lead Stage' },
                    ];
                }
                else {
                    this.cols = [{ field: 'leadStage', header: 'Lead Stage' },
                    { field: 'leadOwner', header: 'Lead Owner' },];

                }
                for (var i = 0; i < months.length; i++) {
                    var monthName = months[i] + "";
                    this.cols.push({ field: monthName.toLowerCase(), header: monthName });
                }

                this.cols.push({ field: 'grandTotal', header: 'Grand Total' },);

                this.reportName = 'Lead by Create Date';
                break;
            }
            case ReportsLeadsTypes.leadsNoActivity: {
                this.cols = [
                    { field: 'leadName', header: 'Lead Name' },
                    { field: 'channel', header: 'Channel' },
                    { field: 'activityType', header: 'Activity Type' },
                    { field: 'comment', header: 'Comment' },
                    { field: 'createdDate', header: 'Last Updated Date' },
                    { field: 'createdBy', header: 'Created By' },
                    { field: 'address', header: 'Address' },
                ];
                this.reportName = 'Lead by No Activity';
                break;
            }
            case ReportsLeadsTypes.leadsAging: {
                this.cols = [
                    { field: 'LeadName', header: 'Lead Name' },
                    { field: 'PrimaryAssocite', header: 'Primary Associte' },
                    { field: 'CurrentStage', header: 'Current Stage' },
                    { field: 'CreatedDate', header: 'Created Date' },
                    { field: 'TotalAge', header: 'Total Age' },
                ];
                this.reportName = 'Lead by Aging';
                break;
            }
            case ReportsLeadsTypes.leadsConverted: {

                var months = this.monthList(new Date(this.dateFrom), new Date(this.dateTo));

                this.cols = [{ field: 'leadOwner', header: 'Lead Owner' }];
                for (var i = 0; i < months.length; i++) {
                    var monthName = months[i] + "";
                    this.cols.push({ field: monthName.toLowerCase(), header: monthName });
                }

                this.cols.push({ field: 'grandTotal', header: 'Grand Total' },);

                this.reportName = 'Lead by Converted';
                break;
            }
            default: {
                break;
            }
        }

         //set filter value
         this.setFilterValues();
    }

    setFilterValues(){
        this.filterByInputValue = [];
        switch (this.selectedWindow) {
            case ReportsLeadsTypes.leadsOwner: {

                const reportsData = ParseHelper.DeepCopy(this.reportsData);

                const oneTypeData = reportsData.filter(obj=> !obj.leadType?.includes(','));
                const moreTypesData = reportsData.filter(obj=> obj.leadType?.includes(','));

                this.filterByInputValue = [...oneTypeData];

                moreTypesData.map(reportDetails=>{
                   const leadTypes = reportDetails.leadType.split(',');

                   leadTypes.map(leadType=>{
                    reportDetails['leadType'] = leadType.trim();
                        this.filterByInputValue.push(reportDetails)
                   })
                });

                this.setClosedLeadsOwnerCharts();
                break;
            }
            case ReportsLeadsTypes.leadsStage: {
                const reportsData = ParseHelper.DeepCopy(this.reportsData);

                const oneTypeData = reportsData.filter(obj=> !obj.leadType?.includes(','));
                const moreTypesData = reportsData.filter(obj=> obj.leadType?.includes(','));

                this.filterByInputValue = [...oneTypeData];

                moreTypesData.map(reportDetails=>{
                   const leadTypes = reportDetails.leadType.split(',');

                   leadTypes.map(leadType=>{
                    reportDetails['leadType'] = leadType.trim();
                        this.filterByInputValue.push(reportDetails)
                   })
                });
                this.setLeadStageBarChart();
                break;
            }
            default:
                this.filterByInputValue = [...this.reportsData];
                break;
        }
        this.reportsFlatData = ParseHelper.DeepCopy(this.filterByInputValue);
    }

    private formatDate(date: Date) {
        return moment(date).format('MM-DD-YYYY');
    }

    camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, '');
    }

    getDifferenceInDays(date1, date2) {
        const diffInMs = Math.abs(date2 - date1);
        return diffInMs / (1000 * 60 * 60 * 24);
    }

    monthList(fromDate: Date, toDate: Date) {
        this.Months = [];
        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ]

        var totalDayDiff = this.getDifferenceInDays(fromDate, toDate);
        var monthStart = fromDate.getMonth();
        var firstMonth = monthNames[monthStart];
        this.Months.push(firstMonth);
        var monthend = toDate.getMonth();

        if (monthStart != monthend) {
            for (var d = 28; totalDayDiff > d; d + 30) {

                var nextDate = new Date(fromDate.setDate(fromDate.getDate() + 28));
                var nextMonthNo = nextDate.getMonth();
                var nextMonth = monthNames[nextMonthNo];
                d = d + 28;
                this.Months.push(nextMonth)
            }
        }
        return this.Months;
    }

    onRemoveFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.onApplyFilter(selectedWindow, selectedFilters);
    }

    onClosePanel(selectedWindow: string): void {
        //this.DownloadReport(selectedWindow);
    }

    //when apply any filter
    onApplyFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.reportsData = ParseHelper.DeepCopy(this.reportsDataCopy);

        if (selectedFilters?.length > 0) {
            switch (this.selectedWindow) {
                default:{
                    selectedFilters?.forEach(filt => {

                        let field: any = this.cols.find(f => f.field == filt.field);
                        if (field?.dataType == "date") {
                            this.reportsData = this.reportsData?.filter(x => {
                                const date = this.localDatePipe.transform(x[filt.field], 'date')
                                return date == filt.value;
                            }) ?? [];
                        }
                        else {

                            if(filt.field=='leadType'){
                                this.reportsData = this.reportsData?.filter(x => x[filt.field]?.includes(filt.value)) ?? [];
                            }else{
                                this.reportsData = this.reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                            }

                        }
                    });
                    break;
                }
            }
        }
        this.setFilterValues();
    }

    //when Edit applied filter
    onModifyFilterOptions(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        let reportsData: any[] = ParseHelper.DeepCopy(this.reportsDataCopy);

        switch (this.selectedWindow) {
            case ReportsLeadsTypes.leadsOwner: {

                const reportsData2 = ParseHelper.DeepCopy(reportsData);

                const oneTypeData = reportsData2.filter(obj=> !obj.leadType?.includes(','));
                const moreTypesData = reportsData2.filter(obj=> obj.leadType?.includes(','));

                reportsData = [...oneTypeData];

                moreTypesData.map(reportDetails=>{
                   const leadTypes = reportDetails.leadType.split(',');

                   leadTypes.map(leadType=>{
                    reportDetails['leadType'] = leadType.trim();
                        reportsData.push(reportDetails)
                   })
                });

                selectedFilters?.forEach(filt => {

                    let field: any = this.cols.find(f => f.field == filt.field);
                    if (field?.dataType == "date") {
                        reportsData = reportsData?.filter(x => this.localDatePipe.transform(x[filt.field], 'date') == filt.value) ?? [];
                    }
                    else {
                        reportsData = reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                    }
                });

                this.filterByInputValue = [];
                this.filterByInputValue = [...reportsData];
                break;
            }
            case ReportsLeadsTypes.leadsStage: {
                const reportsData2 = ParseHelper.DeepCopy(reportsData);

                const oneTypeData = reportsData2.filter(obj=> !obj.leadType?.includes(','));
                const moreTypesData = reportsData2.filter(obj=> obj.leadType?.includes(','));

                reportsData = [...oneTypeData];

                moreTypesData.map(reportDetails=>{
                   const leadTypes = reportDetails.leadType.split(',');

                   leadTypes.map(leadType=>{
                    reportDetails['leadType'] = leadType.trim();
                        reportsData.push(reportDetails)
                   })
                });
                selectedFilters?.forEach(filt => {

                    let field: any = this.cols.find(f => f.field == filt.field);
                    if (field?.dataType == "date") {
                        reportsData = reportsData?.filter(x => this.localDatePipe.transform(x[filt.field], 'date') == filt.value) ?? [];
                    }
                    else {
                        reportsData = reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                    }
                });

                this.filterByInputValue = [];
                this.filterByInputValue = [...reportsData];
                break;
            }
            default:{
                selectedFilters?.forEach(filt => {

                    let field: any = this.cols.find(f => f.field == filt.field);
                    if (field?.dataType == "date") {
                        reportsData = reportsData?.filter(x => this.localDatePipe.transform(x[filt.field], 'date') == filt.value) ?? [];
                    }
                    else {
                        reportsData = reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                    }
                });

                this.filterByInputValue = [];
                this.filterByInputValue = [...reportsData];
                break;
            }
        }
    }

    //When date filter dropdown change
    onChangeRange(selectedWindow: string, event: { dateFrom: any, dateTo: any }): void {
        this.dateFrom = event.dateFrom;
        this.dateTo = event.dateTo;
        this.LeadReport();
    }

    onChangeChannel(selectedChannel){
        this.selectedChannel = selectedChannel;
        this.LeadReport();
    }

    //#region Print, PDF, XLSX

    print() {
        this.appMainService.isShowSpinner('Print');
        this.exportPDF(this.selectedWindow, true);
        this.appMainService.isHideSpinner('Print');
    }

    exportPDF(selectedWindow: string, isPrintFlag = false) {
        this.PDFOpportunityReport(selectedWindow, isPrintFlag, "NoExcel");
    }

    exportXLS(selectedWindow: string) {
        this.PDFOpportunityReport(selectedWindow, false, "exportXLSX");
    }

    exportXLSX(selectedWindow: string) {
        this.PDFOpportunityReport(selectedWindow, false, "exportXLSX");
    }

   async PDFOpportunityReport(selectedWindow: string, isPrintFlag: boolean, isexportXLS: string) {
        this.appMainService.isShowSpinner('ExportLeadReport');

        let dataResult = [];
        let modifiedData = [];
        let reportsData = ParseHelper.DeepCopy(this.reportsData);
        let groupColValue = '';

        reportsData.map((rowData, index) => {
            let obj = {};
            let groupObj = {};
            let data = ParseHelper.DeepCopy(rowData);
            let groupData = ParseHelper.DeepCopy(rowData);

            if(this.groupByFieldName){
                if(index>0){groupColValue = reportsData[index-1][this.groupByFieldName]}
                if(groupColValue!= rowData[this.groupByFieldName]){

                    let cellStyle: CellDef = {
                        styles: {
                            fillColor: "#f1f1f1",
                            textColor: "#495057",
                            fontStyle: "bold"
                        },
                        content: ""
                    }

                    this.tableCols.map(cols => {
                        if (cols.dataType == "datetime")
                            {
                                groupData[cols.field] = cols.groupField ? this.localDatePipe.transform(groupData[cols.groupField]) : '';
                                groupObj[cols.header] = groupData[cols.field];
                            }
                        else if (cols.dataType == 'date') {
                            groupData[cols.field] = cols.groupField ? this.localDatePipe.transform(groupData[cols.groupField], 'date') ?? groupData[cols.groupField] : "";
                            groupObj[cols.header] = groupData[cols.field];
                        }
                        else if (cols.dataType == 'number2dp') {
                            groupData[cols.field] = cols.groupField ? groupData[cols.groupField]?.toFixed(2) ?? groupData[cols.groupField] : "";
                            groupObj[cols.header] = groupData[cols.field];
                        }
                        else if (cols.dataType == 'currencySymbol') {
                            groupData[cols.field] = cols.groupField ? this.currencySymbolPipe.transform(groupData[cols.groupField],'number2dp') ?? groupData[cols.groupField] : "";
                            groupObj[cols.header] = groupData[cols.field];
                        }
                        else if (cols.dataType == 'percentageSymbol') {
                            groupData[cols.field] = cols.groupField ? this.percentageSymbolPipe.transform(groupData[cols.groupField]) ?? groupData[cols.groupField] : "";
                            groupObj[cols.header] = groupData[cols.field];
                        }
                        else
                            {
                                groupData[cols.field] = cols.groupField ? groupData[cols.groupField] : '';
                                groupObj[cols.header] = groupData[cols.field];
                            }
                        cellStyle.content = groupData[cols.field];
                        groupData[cols.field] = ParseHelper.DeepCopy(cellStyle);
                    });

                    if (groupObj) {
                        modifiedData.push(groupData);
                        dataResult.push(groupObj);
                    }
                }
            }


            this.tableCols.map(cols => {
                if (cols.dataType == "datetime")
                    {
                        data[cols.field] = this.localDatePipe.transform(data[cols.field]);
                        obj[cols.header] = data[cols.field];
                    }
                else if (cols.dataType == "date")
                {
                    data[cols.field] = this.localDatePipe.transform(data[cols.field], 'date');
                    obj[cols.header] = data[cols.field];
                }
                else if (cols.dataType == 'number2dp') {
                    data[cols.field] =  parseFloat(data[cols.field])?.toFixed(2) ?? data[cols.field];
                    obj[cols.header] = data[cols.field];
                }
                else if (cols.dataType == 'currencySymbol') {
                    data[cols.field] =  this.currencySymbolPipe.transform(data[cols.field],'number2dp') ?? data[cols.field];
                    obj[cols.header] = data[cols.field];
                }
                else if (cols.dataType == 'percentageSymbol') {
                    data[cols.field] =  this.percentageSymbolPipe.transform(data[cols.field]) ?? data[cols.field];
                    obj[cols.header] = data[cols.field];
                }
                else
                    {
                        obj[cols.header] = data[cols.field];
                    }
            });


            if (obj) {
                modifiedData.push(data);
                dataResult.push(obj);
            }
        });



        if (isexportXLS === "exportXLS" || isexportXLS === "exportXLSX") {

            if (isexportXLS === "exportXLSX") {
               await import("xlsx").then(xlsx => {
                    const worksheet = xlsx.utils.json_to_sheet(dataResult);
                    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
                    this.saveAsExcelFilexlsx(excelBuffer, this.reportName);
                });
            }

            if (isexportXLS === "exportXLS") {
                await import("xlsx").then(xlsx => {
                    const worksheet = xlsx.utils.json_to_sheet(dataResult);
                    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xls', type: 'array' });
                    this.saveAsExcelFilexls(excelBuffer, this.reportName);
                });
            }
        } else {
            let pdfcolumns = [];
            this.tableCols.map(cols => {
                pdfcolumns.push({ dataKey: cols.field, header: cols.header });
            })

            //Print/PDF
            ReportsPrintPdfService.openOrExportAsPDF(pdfcolumns, modifiedData, this.OrganizationName, this.dateFrom, this.dateTo, this.reportName, null, null, isPrintFlag);
            this.noContactFindOrLoadingText = 'No Reports Available.';
        }

        this.appMainService.isHideSpinner('ExportLeadReport');
    }
    saveAsExcelFilexls(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xls';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }
    saveAsExcelFilexlsx(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }

    private saveAsPdfFile(buffer: any, fileName: string): void {
        buffer.save(fileName + '.pdf');
    }

    //Charts

    groupByData(xs, key) {
        const groupList = [];
        const group = xs.reduce(function(rv, x) {
          (rv[x[key]] = rv[x[key]] || []).push(x);
          return rv;
        }, {});

        Object.keys(group).map(k=>{
            let obj = {};
            obj[key] = k;
            obj['dataList'] = group[k];

            groupList.push(obj);
        });

        return groupList;
    };

    setClosedLeadsOwnerCharts(){
        let barData = {
            labels: [],
            datasets: [
                {
                    label: 'Qualified',
                    backgroundColor: '#42A5F5',
                    data: []
                },
                {
                    label: 'UnQualified',
                    backgroundColor: '#FFA726',
                    data: []
                }
            ]
        };

        this.leadsOwnerBarCharts = barData;

        if (!this.reportsData || !this.reportsData.length) {
            return;
        }

        const ownerDetails = this.groupByData(this.reportsData,'leadOwner');

        ownerDetails.filter(data=> data.leadsOwner!='null' && data.leadOwner).map(owner=>{
           if(owner.dataList.length>0){
                const details = owner.dataList as ClosedLeadsOwnerReports[];

                const qualified = details.filter(obj=>obj.leadStage=='Qualified').length||0;
                const notQualified = details.filter(obj=>obj.leadStage=='UnQualified').length||0;

                barData.labels.push(owner.leadOwner);
                barData.datasets[0].data.push(qualified);
                barData.datasets[1].data.push(notQualified);
           }
        });

        this.leadsOwnerBarCharts = barData;
    }

    setLeadStageBarChart(){
        let stackedData = {
            labels: [],
            datasets: []
        };

        this.leadsStageBarCharts = stackedData;

        if (!this.reportsData || !this.reportsData.length) {
            return;
        }

        const stageDetails = this.groupByData(this.reportsData,'leadStage');
        const ownerDetails = this.groupByData(this.reportsData,'leadOwner');

        stageDetails.map(stage=>{
            stackedData.labels.push(stage.leadStage);
        });

        const randColors = this.randColor(ownerDetails.length);

        ownerDetails.map((owner, index)=>{
                const dataSets = {
                    type: 'bar',
                    label: owner.leadOwner,
                    backgroundColor: randColors[index],
                    data: []
                }

                stackedData.labels.map(label=>{
                    const leadCount = owner.dataList.filter(lead=>lead.leadStage==label).length||0;
                    dataSets.data.push(leadCount);
                });

                stackedData.datasets.push(dataSets);
        });

        this.leadsStageBarCharts = stackedData;
    }

    getColor(index){

        const colorList = ['#42A5F5','#66BB6A','#FFA726','#7E57C2','#26A69A',"#FF6384","#36A2EB"];

        if(index>6){
            let i = index%6;
            return colorList[i];
        }else{
            return colorList[index];
        }
    }

    randColor(numColors) {
        const chars = "ABCDEF0123456789";
        const size = chars.length;
        let str = [];

        for(let i = 0; i < numColors; i++ ) {
            str[i] = "#";
            for(let j = 0; j < 6; j++ ) {
                const rand = Math.floor(Math.random() * (size - 1)) + 1;
                str[i] += chars[rand];
            }
        }
        return str;
    }

    closeFilterPopup(){
        this.displayFilterPopup = false;
        this.onCloseFilterPopup.emit(false);
    }

    setAddedFilters(){
        const addedDateRange = DATE_RANGE_LIST.find(range=>range.code==this.selectedReportFilters.dateFilter);
        const filterValues: ReportsAllFiltersAppyModels = {
            applyMode: ReportsAllFiltersApplyModes.applyOnly,
            dateFilter: {
                ...addedDateRange,
                fromDate: this.dateFrom,
                toDate: this.dateTo
            },
            leadChannel: this.selectedChannel
        }

        this.onUpdateAllFilters.emit(filterValues);
    }

    allFiltersChanges(filterValues: ReportsAllFiltersAppyModels){
        this.reportsFilterApplyMode = filterValues.applyMode;
        this.dateFrom = filterValues?.dateFilter?.fromDate || this.dateFrom;
        this.dateTo = filterValues?.dateFilter?.toDate || this.dateTo;
        this.selectedChannel = filterValues?.channel || this.selectedChannel;
        filterValues.leadChannel =  this.selectedChannel;
        this.LeadReport();

        this.onUpdateAllFilters.emit(filterValues)
    }
}
